var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { ChangeEvent, DragEvent, FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Endpoints } from "@brg/api";
import { useToasts } from "@brg/ui";
// import { useEffect } from "@storybook/addons";
import Uppy, { StrictTypes } from "@uppy/core";
import { FileInput } from "@uppy/react";
import styled from "styled-components";
import { Tus } from "uppy";
//@ts-ignore
import Uploadimage from '../../../../../images/icons/upload.svg';
import { ALLOWED_FILE_TYPES } from "../../editor/chooseel";
import { LayoutConst } from "../../../../../core/modules/layout.module";
import { useIsMobile } from "@brg/ui";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 100px;\n    height: 100%;\n    padding: 48px;\n    display: grid;\n    flex-grow: 1;\n    @media (max-width: ", "px) {\n        padding: 10px;\n    }\n"], ["\n    min-height: 100px;\n    height: 100%;\n    padding: 48px;\n    display: grid;\n    flex-grow: 1;\n    @media (max-width: ", "px) {\n        padding: 10px;\n    }\n"])), LayoutConst.screen.s);
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    border: 2px dashed #838382;\n    min-height: 100px;\n    height: 100%;\n    position: relative;\n    opacity: ", ";\n    input[type=\"file\"] {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        z-index: 5;\n        opacity: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    border: 2px dashed #838382;\n    min-height: 100px;\n    height: 100%;\n    position: relative;\n    opacity: ", ";\n    input[type=\"file\"] {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        z-index: 5;\n        opacity: 0;\n    }\n"])), function (p) { return p.isDragged || p.itemHover ? 0.7 : 1; });
var DropTitle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #70706F;\n"], ["\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #70706F;\n"])));
var createUploader = function (onBeforeUpload, onComplete, setIsLoading) {
    var uploader = Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        allowMultipleUploads: false,
        meta: { type: 'image/jpeg' },
        autoProceed: true,
        onBeforeUpload: onBeforeUpload,
    })
        .use(Tus, {
        id: 'Tus',
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304,
    });
    uploader.on('complete', function (result) {
        try {
            if (typeof (onComplete) === 'function') {
                onComplete(result);
            }
            setIsLoading(false);
        }
        catch (e) {
            console.error(e);
        }
    });
    return uploader;
};
export var UploadBlock = function (props) {
    var onBeforeUpload = props.onBeforeUpload, onComplete = props.onComplete;
    // const [itemHover, setItemHover] = useState('');
    var _a = useState(''), itemDrag = _a[0], setItemDrag = _a[1];
    var _b = useState(false), isDragged = _b[0], setIsDragged = _b[1];
    var _c = useState(false), Loading = _c[0], setIsLoading = _c[1];
    var _d = useState(null), uploader = _d[0], setUploader = _d[1];
    var error = useToasts().error;
    var isMobile = useIsMobile();
    var inputRef = useRef();
    // console.log('UploadBlock', Uploadimage)
    var beforeUpload = useCallback(function (props) {
        setIsLoading(true);
        if (typeof (onBeforeUpload) === 'function') {
            onBeforeUpload(props);
        }
    }, []);
    useEffect(function () {
        if (inputRef.current) {
            setUploader(createUploader(beforeUpload, onComplete, setIsLoading));
        }
    }, [inputRef.current]);
    var onDropFile = useCallback(function (e, zone) {
        try {
            var filesInit = e.target.files;
            if (!filesInit) {
                return;
            }
            var files = Array.from(filesInit);
            var uploadIsAllowed = files.every(function (_a) {
                var type = _a.type;
                return ALLOWED_FILE_TYPES.includes(type);
            });
            if (!uploadIsAllowed) {
                error("\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B: jpg, gif, png");
                return;
            }
            var file = files[0];
            uploader === null || uploader === void 0 ? void 0 : uploader.addFile({
                source: 'file input',
                name: file.name,
                type: file.type || 'application/octet-stream',
                data: file,
                meta: {
                    contentType: file.type || 'application/octet-stream'
                }
            });
        }
        catch (err) {
            if (err.isRestriction) {
                console.error('Restriction error:', err);
            }
            else {
                console.error(err);
            }
        }
    }, [uploader]);
    var fileDrag = useCallback(function (e, style) {
        e.stopPropagation();
        setItemDrag(style);
    }, []);
    var leaveWrapTarget = useCallback(function (e) {
        if (e.relatedTarget === null) {
            setIsDragged(false);
            return;
        }
        //@ts-ignore
        var relatedTargetTag = e.relatedTarget.tagName;
        if (relatedTargetTag === 'INPUT')
            return;
        setIsDragged(false);
    }, []);
    return React.createElement(Container, { className: "col-12 spec-upload-block-container" },
        React.createElement(Wrapper, { onDragEnter: function () { return setIsDragged(true); }, onDragLeave: function (e) { return leaveWrapTarget(e); }, isDragged: isDragged },
            React.createElement("img", { src: Uploadimage }),
            React.createElement(DropTitle, null, isMobile
                ? 'Choose your own image from your device'
                : 'Drop your own image here, or choose it from your device'),
            React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", ref: inputRef, onChange: function (e) { return onDropFile(e, 'big'); }, onDragEnter: function (e) { return fileDrag(e, 'big'); }, onDragLeave: function (e) { return fileDrag(e, ''); }, multiple: false })));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=uploadblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { ChangeEvent, DragEvent, FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Endpoints } from "@brg/api";
import { useToasts } from "@brg/ui";
// import { useEffect } from "@storybook/addons";
import Uppy, { StrictTypes } from "@uppy/core";
import { FileInput } from "@uppy/react";
import styled from "styled-components";
import { Tus } from "uppy";
//@ts-ignore
import Uploadimage from '../../../../../images/icons/upload.svg';
import { ALLOWED_FILE_TYPES } from "../../editor/chooseel";
import { LayoutConst } from "../../../../../core/modules/layout.module";
import { useIsMobile } from "@brg/ui";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 100px;\n    height: 100%;\n    padding: 48px;\n    display: grid;\n    flex-grow: 1;\n    @media (max-width: ", "px) {\n        padding: 10px;\n    }\n"], ["\n    min-height: 100px;\n    height: 100%;\n    padding: 48px;\n    display: grid;\n    flex-grow: 1;\n    @media (max-width: ", "px) {\n        padding: 10px;\n    }\n"])), LayoutConst.screen.s);
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    border: 2px dashed #838382;\n    min-height: 100px;\n    height: 100%;\n    position: relative;\n    opacity: ", ";\n    input[type=\"file\"] {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        z-index: 5;\n        opacity: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    border: 2px dashed #838382;\n    min-height: 100px;\n    height: 100%;\n    position: relative;\n    opacity: ", ";\n    input[type=\"file\"] {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        z-index: 5;\n        opacity: 0;\n    }\n"])), function (p) { return p.isDragged || p.itemHover ? 0.7 : 1; });
var DropTitle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #70706F;\n"], ["\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #70706F;\n"])));
var createUploader = function (onBeforeUpload, onComplete, setIsLoading) {
    var uploader = Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        allowMultipleUploads: false,
        meta: { type: 'image/jpeg' },
        autoProceed: true,
        onBeforeUpload: onBeforeUpload,
    })
        .use(Tus, {
        id: 'Tus',
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304,
    });
    uploader.on('complete', function (result) {
        try {
            if (typeof (onComplete) === 'function') {
                onComplete(result);
            }
            setIsLoading(false);
        }
        catch (e) {
            console.error(e);
        }
    });
    return uploader;
};
export var UploadBlock = function (props) {
    var onBeforeUpload = props.onBeforeUpload, onComplete = props.onComplete;
    // const [itemHover, setItemHover] = useState('');
    var _a = useState(''), itemDrag = _a[0], setItemDrag = _a[1];
    var _b = useState(false), isDragged = _b[0], setIsDragged = _b[1];
    var _c = useState(false), Loading = _c[0], setIsLoading = _c[1];
    var _d = useState(null), uploader = _d[0], setUploader = _d[1];
    var error = useToasts().error;
    var isMobile = useIsMobile();
    var inputRef = useRef();
    // console.log('UploadBlock', Uploadimage)
    var beforeUpload = useCallback(function (props) {
        setIsLoading(true);
        if (typeof (onBeforeUpload) === 'function') {
            onBeforeUpload(props);
        }
    }, []);
    useEffect(function () {
        if (inputRef.current) {
            setUploader(createUploader(beforeUpload, onComplete, setIsLoading));
        }
    }, [inputRef.current]);
    var onDropFile = useCallback(function (e, zone) {
        try {
            var filesInit = e.target.files;
            if (!filesInit) {
                return;
            }
            var files = Array.from(filesInit);
            var uploadIsAllowed = files.every(function (_a) {
                var type = _a.type;
                return ALLOWED_FILE_TYPES.includes(type);
            });
            if (!uploadIsAllowed) {
                error("\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B: jpg, gif, png");
                return;
            }
            var file = files[0];
            uploader === null || uploader === void 0 ? void 0 : uploader.addFile({
                source: 'file input',
                name: file.name,
                type: file.type || 'application/octet-stream',
                data: file,
                meta: {
                    contentType: file.type || 'application/octet-stream'
                }
            });
        }
        catch (err) {
            if (err.isRestriction) {
                console.error('Restriction error:', err);
            }
            else {
                console.error(err);
            }
        }
    }, [uploader]);
    var fileDrag = useCallback(function (e, style) {
        e.stopPropagation();
        setItemDrag(style);
    }, []);
    var leaveWrapTarget = useCallback(function (e) {
        if (e.relatedTarget === null) {
            setIsDragged(false);
            return;
        }
        //@ts-ignore
        var relatedTargetTag = e.relatedTarget.tagName;
        if (relatedTargetTag === 'INPUT')
            return;
        setIsDragged(false);
    }, []);
    return React.createElement(Container, { className: "col-12 spec-upload-block-container" },
        React.createElement(Wrapper, { onDragEnter: function () { return setIsDragged(true); }, onDragLeave: function (e) { return leaveWrapTarget(e); }, isDragged: isDragged },
            React.createElement("img", { src: Uploadimage }),
            React.createElement(DropTitle, null, isMobile
                ? 'Choose your own image from your device'
                : 'Drop your own image here, or choose it from your device'),
            React.createElement("input", { type: "file", accept: "image/jpeg, image/gif, image/png", ref: inputRef, onChange: function (e) { return onDropFile(e, 'big'); }, onDragEnter: function (e) { return fileDrag(e, 'big'); }, onDragLeave: function (e) { return fileDrag(e, ''); }, multiple: false })));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=uploadblock.js.map